
import Report from '@/components/Report.vue'
import Tables from '@/components/common/TablesDb.vue'
import InputText from '@/components/common/InputText.vue'
import { defineComponent, ref, computed, markRaw, watch } from 'vue'
import { useApi } from '@/lib/api'
import { useRoute } from 'vue-router'
import { downloadStream, useAppViewedList } from '@/lib/common'
import { useStore } from 'vuex'

const actions = markRaw({
  template: `<router-link :to="{params: {id: data.id }}" tag="a" class="text-bold">Preglej </router-link>`,
  props: {
    data: {}
  }
})

export default defineComponent({
  components: { Tables, Report, InputText },
  setup() {
    const { recordExists } = useAppViewedList()
    const _store = useStore()
    const _api = useApi()
    const _route = useRoute()
    const cols = ref([
      { field: 'id', caption: '#', dbField: 'id', hidden: true },
      { field: 'contract.client.title', caption: 'Naročnik', dbField: 'narocnik' },
      { field: 'contract.jnTitle', caption: 'Št. JN', dbField: 'jn' },
      { field: 'contract.internalId', caption: 'Int. št. pogodbe', dbField: 'interni_opis' },
      { field: 'contract.title', caption: 'Pogodba', dbField: 'pogodba' },
      { field: 'reportType', caption: 'Tip poročila', dbField: 'tip' },
      { field: 'date', caption: 'Obdobje', format: { type: 'date', format: 'MMMM YYYY' }, dbField: 'datum' },
      { field: 'user', caption: 'Uporabnik', dbField: 'upor' },
      { field: 'dateUpdate', caption: 'Datum poročanja', format: { type: 'date', format: 'DD.MM.YYYY HH:mm' }, dbField: 'P.date_update', class: 'nowrap' },
      { caption: 'Akcija', component: actions, class: 'nowrap actions' }
    ])
    const data = ref([])
    const filter = ref({ pagerPage: 1, pagerPageSize: 20, pagerSort: 'date_update desc' })
    const hasId = computed(() => _route.params.id)

    const getData = async (e?: any, f?: any) => {
      if (!hasId.value) {
        if (e) {
          filter.value.pagerPage = e.page
          filter.value.pagerSort = e.sort ? e.sort : 'date_update desc'
        } else if (filter.value.pagerPage > 1) {
          if (f) {
            filter.value.pagerPage = 1
          }
          return
        }
        const res = await _api.post<any>('adminReportList', filter.value, true)
        data.value = res.data
      }
    }

    const toXls = async () => {
      _store.commit('appLoading', true)
      try {
        const res = await _api.axios.post<any>('adminReportList?export=true', filter.value, { responseType: 'blob' })
        if (res.status === 200) {
          downloadStream(res.data, 'Seznam_porocil.xlsx')
        }
      } finally {
        _store.commit('appLoading', false)
      }
    }

    watch(hasId, () => getData())

    getData()

    return { cols, data, filter, getData, hasId, toXls, recordExists }
  }
})
